import React, { useContext, useMemo } from 'react';

import { BirthdayInput as Input } from '../../../components/ui/Inputs/BirthdayInput';
import { useContent } from '../../../hooks/useContent';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

export function BirthdayInput() {
  const { bindBirthday, isLoading, invalidFields } = useContext(SignUpFormContext);
  const { value } = bindBirthday || {};
  const { getContentByPath } = useContent();
  useFieldErrorAnalytics({ field: 'birthday', invalidFields });

  const error = useMemo(
    (): string | undefined =>
      invalidFields.includes('birthday')
        ? getContentByPath(`accountCreation.fields.birthday.${value?.replace('MM/DD/YYYY', '') ? 'error' : 'empty'}`)
        : undefined,
    [getContentByPath, invalidFields, value],
  );

  return (
    <Input
      label={getContentByPath('accountCreation.fields.birthday.title')}
      id='birthDay'
      testId='birthDay'
      disabled={isLoading}
      hint={error || getContentByPath('accountCreation.fields.birthday.hint')}
      error={!!error}
      {...bindBirthday}
    />
  );
}
